import React from "react";

// Retain table semantics on desktop; expose column labels in narrow record views.
export const LedgerTable = ({ labels, children, className = "", ...props }) => {
  const prefix = props["data-testid"];
  const decorate = (nodes, path = "row") => React.Children.map(nodes, (node, index) => {
    if (!React.isValidElement(node)) return node;
    const key = `${path}-${node.key ?? index}`;
    if (node.type === "tr") return React.cloneElement(node, {}, React.Children.map(node.props.children, (cell, column) => {
      if (!React.isValidElement(cell) || cell.type !== "td") return cell;
      return React.cloneElement(cell, {
        "data-label": cell.props.colSpan ? undefined : labels[column],
        "data-testid": cell.props["data-testid"] || `${prefix}-${key}-cell-${column}`,
      });
    }));
    if (node.type === "tbody" || node.type === React.Fragment) return React.cloneElement(node, {}, decorate(node.props.children, key));
    return node;
  });
  return <table {...props} className={`ledger-responsive ${className}`}>{decorate(children)}</table>;
};